import { Link as GatsbyLink } from 'gatsby';
import React from 'react';

const Link: React.FC<
  React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  >
> = ({ href, ref, children, ...props }) => {
  const isExternal = ['http', 'ftp', 'mailto', 'tel'].some((prefix) =>
    href.startsWith(prefix),
  );

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }

  return (
    <GatsbyLink to={href} {...props}>
      {children}
    </GatsbyLink>
  );
};

export default Link;
